/**
 * enum的な値を記述するファイル
 */

/**
 * 追加情報のUIを定義するenum値
 */
export const EnumAttachedItems = {
  ValidationType: {
    Text: 1,
    TextArea: 2,
    PostCodeJp: 3,
    TelNumberJp: 4,
    Name: 5,
    Prefecture: 6,
    Address: 7,
    ShootingPosition: 8,
    ShootingDate: 9,
    DisplayName: 10
  }
};

export const EnumPurposeTypes = {
  Published: 1, //表示用情報
  Shipping: 2 //配送用情報
};

export const EnumSourceTypes = {
  CampaignSystem: 1,
  Instagram: 2,
  Twitter: 3
};

export const EnumSubmissionType = {
  HiRes: 1,
  Original: 2
};

export const EnumSubmissionFileType = {
  HiRes: 1
};

//ステータスコード
export const EnumStatuses = {
  Defeat: 1,
  AdvanceWinningCandidate: 2,
  WaitingInitialContact: 3,
  WaitingDataSubmission: 4,
  WaitingDataCheck: 5,
  DataReceived: 6,
  WaitingWorkInformationInput: 7,
  WaitingWorkInformationCheck: 8,
  WaitingProductShipping: 9,
  Completed: 10
};

export const EnumWorkCheckListResponseStatus = {
  Answerd: 1,
  NotAvailable: 2
};
